<script setup>
import {defineProps, ref} from "vue";
import useHelper from "@/composables/useHelper";
import {useContentStore} from "@/stores/ContentStore";

const {getButtonClass, getQuestButtonLabel, isMobile, isSafari} = useHelper();

const props = defineProps({
    disabled: Boolean,
    content: Object,
    index: Number,
    mobile: Boolean
});
const isActive = ref(false)
const classes = props.mobile ? 'mt-4 rounded w-full py-3 text-xs text-white lg:hidden' : 'mt-3 w-48 rounded-full py-3 text-xs text-white hidden lg:block';
const store = useContentStore();

async function getSeamlessLink(id) {
    isActive.value = true;

    const link = await store.getLink(id);

    if (isMobile() || isSafari()) { //mobile
      window.location.href = link; // Open in the same page on mobile devices
    }
    else {
      window.open(link, 'quest'); // open in a new tab on desktop
    }

    isActive.value = false;
}

</script>

<template>
    <button :disabled="props.disabled"
            @click.prevent="getSeamlessLink(props.content.id)"
            :class="getButtonClass(classes, props.content, props.index)">
        <div class="flex items-center justify-center space-x-2">
            <span> {{ isActive ? $tt('content_card__button_loading') + ' ...' : getQuestButtonLabel(props.content) }} </span>
        </div>
    </button>
</template>

